/** App Spy (AppStoreSpy) tab — search / package lookup / top charts / logs sub-views. */
export const appSpy: Record<string, string> = {
  'appSpy.tabSearch': 'Tìm kiếm',
  'appSpy.tabLookup': 'Tra cứu gói',
  'appSpy.tabTopCharts': 'Bảng xếp hạng',
  'appSpy.tabLogs': 'Nhật ký',
  'appSpy.platform': 'Nền tảng',
  'appSpy.android': 'Android',
  'appSpy.ios': 'iOS',
  'appSpy.keyword': 'Từ khóa',
  'appSpy.keywordPlaceholder': 'vpn, calculator, photo…',
  'appSpy.top': 'Top',
  'appSpy.package': 'Gói',
  'appSpy.packagePlaceholderAndroid': 'com.facebook.katana',
  'appSpy.packagePlaceholderIos': 'VD: 284882215 (Facebook app ID)',
  'appSpy.lookupBtn': 'Tra cứu',
  'appSpy.apps': 'ứng dụng',
  'appSpy.sortDaily': 'Sắp xếp: Cài đặt/ngày',
  'appSpy.sortMonthly': 'Sắp xếp: Cài đặt/tháng',
  'appSpy.sortRevenue': 'Sắp xếp: Doanh thu/tháng',
  'appSpy.sortRating': 'Sắp xếp: Đánh giá',
  'appSpy.exportBtn': 'Xuất file',
  'appSpy.colDailyInstalls': 'Cài đặt/ngày',
  'appSpy.colTotalInstalls': 'Tổng cài đặt',
  'appSpy.colMonthlyInstalls': 'Cài đặt/tháng',
  'appSpy.colMonthlyRevenue': 'Doanh thu/tháng',
  'appSpy.colRating': 'Đánh giá',
  'appSpy.colReleased': 'Phát hành',
  'appSpy.colUpdated': 'Cập nhật',
  'appSpy.colDeveloper': 'Nhà phát triển',
  'appSpy.emptySearch': 'Nhập từ khóa và nhấn Tìm kiếm',
  'appSpy.emptyLookup': 'Nhập tên gói và nhấn Tra cứu',
  'appSpy.chartTitle': 'Cài đặt theo ngày',
  'appSpy.range7d': '7 ngày',
  'appSpy.range30d': '30 ngày',
  'appSpy.range90d': '90 ngày',
  'appSpy.rangeCustom': 'Tùy chỉnh',
  'appSpy.apply': 'Áp dụng',
  'appSpy.statDailyInstalls': 'Cài đặt/ngày',
  'appSpy.statMonthlyInstalls': 'Cài đặt/tháng',
  'appSpy.statTotalInstalls': 'Tổng cài đặt',
  'appSpy.statDailyRevenue': 'Doanh thu/ngày',
  'appSpy.statMonthlyRevenue': 'Doanh thu/tháng',
  'appSpy.statReviews': 'Lượt đánh giá',
  'appSpy.version': 'Phiên bản',
  'appSpy.size': 'Dung lượng',
  'appSpy.price': 'Giá',
  'appSpy.free': 'Miễn phí',
  'appSpy.iap': 'Mua trong ứng dụng',
  'appSpy.store': 'Cửa hàng',
  'appSpy.topCountries': 'Quốc gia hàng đầu',
  'appSpy.collection': 'Bảng xếp hạng',
  'appSpy.rankFrom': 'Hạng từ',
  'appSpy.rankTo': 'Hạng đến',
  'appSpy.compareDate': 'So sánh với',
  'appSpy.loadBtn': 'Tải',
  'appSpy.colRank': 'Hạng',
  'appSpy.colChange': 'Thay đổi',
  'appSpy.new': 'MỚI',
  'appSpy.logsFilterBtn': 'Lọc',
  'appSpy.logsClearBtn': 'Xóa lọc',
  'appSpy.colAction': 'Hành động',
  'appSpy.colQuery': 'Truy vấn',
  'appSpy.colPlatform': 'Nền tảng',
  'appSpy.colResults': 'Kết quả',
  'appSpy.logsEmpty': 'Không có nhật ký',
  'appSpy.total': 'tổng',
  'appSpy.copyPackage': 'Sao chép package name',
  'appSpy.copyAppId': 'Sao chép ID ứng dụng',
  'appSpy.noCompareChart': 'Không có bảng xếp hạng của ngày so sánh',
};
